import {
    Drawer,
    DrawerContent,
    DrawerTrigger,
} from "@/components/ui/drawer"
import { Button } from "@/components/ui/button";
import { CompraRapidaPage } from "@/pages/CompraRapida";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthProvider";
import { useCarrinho } from "@/contexts/CarrinhoProvider";
import { CardsQuantidadePresetCompraRapida, StepperQuantidadeCompraRapida } from "@/components/SeletorQuantidadeCompraRapida";

export function CompraRapida() {
    const [quantidade, setQuantidade] = useState(1);
    const navigate = useNavigate()
    const { isAuthorized } = useAuth()
    const { addItemSurpresinha, limparCarrinho } = useCarrinho()

    async function handleCompraRapida() {
        if (isAuthorized) {
            await limparCarrinho();
            await addItemSurpresinha(quantidade);
            navigate('/compra/finalizar', { replace: true })
            navigate(0)
        } else {
            navigate('/compra/rapida?qtd=' + quantidade)
        }
    }

    return (
        <div className="flex flex-col items-center gap-4 mt-8 mb-2 mx-1">
            <CardsQuantidadePresetCompraRapida
                quantidade={quantidade}
                onChange={setQuantidade}
            />

            <div className="flex flex-col md:flex-row items-center justify-center gap-4">
                <h1 className="text-center text-primary font-semibold text-xl">
                    Compra Rápida
                </h1>
                <StepperQuantidadeCompraRapida
                    quantidade={quantidade}
                    onChange={setQuantidade}
                />

                {
                    isAuthorized ? (
                        <div className="flex justify-center items-center">
                            <Button className="w-40 items-center justify-center" onClick={handleCompraRapida} disabled={quantidade === 0} >
                                {
                                    quantidade > 0 ? 'Comprar' : 'Selecione a Quantidade'
                                }
                            </Button>
                        </div>) :
                        (
                            <Drawer direction="right">
                                <DrawerTrigger className="flex justify-center items-center" asChild>
                                    <Button className="w-40 items-center justify-center" onClick={handleCompraRapida} disabled={quantidade === 0} >
                                        {
                                            quantidade > 0 ? 'Comprar' : 'Selecione a Quantidade'
                                        }
                                    </Button>
                                </DrawerTrigger>
                                <DrawerContent className="min-h-[50%]">
                                    <CompraRapidaPage />
                                </DrawerContent>
                            </Drawer>
                        )
                }
            </div>
        </div>
    )
}